import { useState } from "react";
import { Badge, BlockStack, Button, Checkbox, Modal, RadioButton, Text, TextField } from './admin-ui';
import UpsellProduct from "./UpsellProduct";
import { matchesProduct } from "../utils/upsellAdmin";

export default function UpsellProductPicker({ mode, products, selected, rules, busy, error, onClose, onSubmit }) {
  const [query, setQuery] = useState("");
  const [choices, setChoices] = useState(mode === "create" ? [] : selected);
  const creating = mode === "create";
  const existing = new Set(rules.map((rule) => String(rule.product_id)));
  const filtered = products.filter((product) => matchesProduct(product, query));
  const toggle = (id, checked) => setChoices((current) => checked ? [...current, id] : current.filter((value) => value !== id));

  return <Modal open onClose={() => !busy && onClose()} title={creating ? "Create upsell rule" : "Select recommended products"}
    primaryAction={{ content: creating ? "Create rule" : `Use selection (${choices.length})`, onAction: () => onSubmit(choices), loading: busy, disabled: creating && !choices.length }}
    secondaryActions={[{ content: "Cancel", onAction: onClose, disabled: busy }]}>
    <Modal.Section>
      <BlockStack gap="400">
        <Text as="p" tone="subdued">{creating ? "Choose the purchased product that will trigger this recommendation." : "Choose the optional products to offer after payment. Changes apply when you save the rule."}</Text>
        {error && <p role="alert" className="upsell-error">{error}</p>}
        <TextField label="Search products" labelHidden placeholder="Search by name, handle or product ID" value={query} onChange={setQuery} autoComplete="off" clearButton onClearButtonClick={() => setQuery("")} />
        {!creating && <div className="upsell-picker-summary"><Badge>{`${choices.length} selected`}</Badge><Button variant="plain" disabled={busy || !choices.length} onClick={() => setChoices([])}>Clear selection</Button></div>}
        <div className="upsell-picker-list">
          {filtered.map((product) => {
            const id = String(product.id);
            const hasRule = creating && existing.has(id);
            const inactive = !creating && product.status != null && Number(product.status) !== 1;
            const checked = choices.includes(id);
            const label = <span className="upsell-picker-product"><UpsellProduct product={product} />{hasRule ? <Badge>Rule exists</Badge> : inactive ? <Badge tone="attention">Not active</Badge> : null}</span>;
            return <div className="upsell-picker-row" key={id}>
              {creating
                ? <RadioButton name="upsell-trigger-product" id={`trigger-${id}`} label={label} checked={checked} disabled={busy || hasRule} onChange={() => setChoices([id])} />
                : <Checkbox label={label} checked={checked} disabled={busy || (inactive && !checked)} onChange={(value) => toggle(id, value)} />}
            </div>;
          })}
          {!filtered.length && <div className="upsell-empty"><strong>{products.length ? "No matching products" : "No products available"}</strong><p>Try another search or sync your store products.</p></div>}
        </div>
      </BlockStack>
    </Modal.Section>
  </Modal>;
}
